<template lang="html">
  <div class="">
    <div class="wrapper">
       <div class="chapter">
          <div class="mainpro">
          <div class="singlepro" v-for="(p , index) in pro">
            <div class="proname">
                <h3>{{p.pro_name}}</h3>

            </div>
            <div class="shop">
              <div class="tekstmob" >
                <details style="text-align:right; padding:10px; font-size:13px">
                  <summary >Detaljnije</summary>
                    <p style="text-align: justify; margin-top: 40px;line-height: 20px" v-html="p.pro_opis"></p>
                </details>

              </div>
                <!-- <h3 class="title">{{p.pro_name}}</h3> -->
                <div class="brend">
                  <img   :src="brandurl+p.bra_id"  alt=""  >
                </div>

                <div class="slika">
                  <img :src="proprourl+p.pro_id"  alt=""  >

                </div>
                <div class="kolicinamob">

                  <div class="kol" @click="savet()">
                    <!-- <i class="fas fa-tint" v-if="$route.params.kategorije == 'SEMENA POVRĆA'"></i><button  type="" name="" v-if="$route.params.kategorije == 'SEMENA POVRĆA'">Tehnologija uzgoja</button> -->
                  </div>
                  <div class="kol" @click="term($event, p.pro_id, p.pro_name)">
                    <i class="far fa-images"></i><button  type="" name="">Galerija</button>
                  </div>
                  <div class="" v-if="p.pro_permision !== null">
                    <input type="button" name="" value="Poruči" @click="poruci(p.pro_id)"><i class="fas fa-cart-arrow-down"></i>
                  </div>
                </div>
            </div>
            <div class="tekst" >
              <div class="op">
                <p v-html="p.pro_opis"></p>
              </div>
            </div>

            <div class="kolicina">

              <div class="kol" @click="savet()">
                <!-- <i class="fas fa-tint" v-if="$route.params.kategorije == 'SEMENA POVRĆA'"></i><button  type="" name="" v-if="$route.params.kategorije == 'SEMENA POVRĆA'">Tehnologija uzgoja</button> -->
              </div>
              <div class="kol" @click="term($event, p.pro_id, p.pro_name)">
                <i class="far fa-images"></i><button  type="" name="">Galerija</button>
              </div>
              <div class="" v-if="p.pro_permision !== null">
                <input type="button" name="" value="Poruči" @click="poruci(p.pro_id)"><i class="fas fa-cart-arrow-down"></i>
              </div>
            </div>

          </div>


          </div>
          <div class="levo">
            <div id="ikona" class="ikona">
              <img class="stop"  src="static/imgs/stopgmo.jpg" alt="" v-if="$route.params.kategorije == 'SEMENA POVRĆA' ">
              <img class="stop"  src="static/imgs/Substrati.jpg" alt="" v-if="$route.params.kategorije == 'SUPSTRATI' ">
              <!-- <img class="stop"  src="static/imgs/icl.jpg" alt="" v-if="$route.params.podkategorije == 'Osnovna đubriva' || $route.params.podkategorije == 'Vodotopiva đubriva' || $route.params.podkategorije == 'Folijarna đubriva' "> -->
              <!-- <img class="stop"  src="static/imgs/Adob.png" alt="" v-if="$route.params.podkategorije == 'Đubriva za specijanlne namene' "> -->
              <!-- <img class="stop"  src="static/imgs/icl.jpg" alt="" v-if="$route.params.podkategorije == 'Osnovna đubriva' "> -->
              <img class="stop"  src="static/imgs/POLITIV FOLIJE.png" alt="" v-if="$route.params.kategorije == 'FOLIJE' ">
              <img class="stop"  src="static/imgs/biobest.jpg" alt="" v-if="$route.params.kategorije == 'POLINACIJA' ">
            </div>
            <div id="naslov" class="naslov">
              <p v-if="$route.params.kategorije == 'SEMENA POVRĆA' "><strong>Kao protivnici primene GMO tehnologija, zadovoljstvo nam je što možemo da istaknemo da semenske kuće sa kojima sarađujemo koriste isključivo tradicionalne (prirodne) metode ukrštanja i selekcije.</strong> </p>
              <p v-if="$route.params.kategorije == 'SUBSTRATI' "><strong>Zahvaljujući izuzetnom kvalitetu i tradiciji proizvodnje koja da­tira još od 1905. godine
                 Pindstrup supstrati izbor su profesionalnih proizvođača u više od stotinu zemalja sveta. Najbolja potvrda kvaliteta jeste da je i kod nas za svega ne­koliko godina,
                 Pindstrup preuzeo primat na tržištu. Prepoznatljiv po izgledu ambalaže, uveliko je postao prvi iz­bor svih proizvođača
                  širom zemlje kojima su sigur­nost u proizvodnji i rast prinosa prioriteti. <br><br>* Pre zasnivanja proizvodnje obavezno uraditi analizu vode i za sve nejasnoće kontaktirati stručnu službu preduzeća Virginia d.o.o.</strong></p>
                  <p v-if="$route.params.podkategorije == 'Cvećarstvo' ">
                    <br>
                   Cvećarstvo je oblast poljoprivrede gde kvalitet supstrata najviše dolazi do izražaja. Prednost primene Pindstrup supstrata prepoznao je veliki broj proizvođača cveća u Srbiji.
                    Uz fizičko hemijske osobine koje pružaju dodatnu sigurnost, proizvođači usled bolje kompresovanosti džaka dobijaju više za svoj novac.
                    Superioran vodno vazdušni režim doprinosi ređoj pojavi bolesti, ali isto tako i boljem razvoju korena, što je presudno bitno za kvalitet proizvoda.
                  </p>
              <p v-if="$route.params.podkategorije == 'Biološka zaštita' "><strong>Virginia d.o.o. Beograd</strong>  je prvo preduzeće u Srbiji koje je uspelo
              primenom bioloških mera borbe protiv štetočina staviti pod kontrolu neke od najopasnijih štetočina kod nas.
               Dugogodišnje iskustvo, kvalitetan ino dobavljač, redovni i vanredni česti uvozi, kvalitetno praćenje proizvodnje i iskusna stručna služba,
               preduslov su uspešne kontrole štetočina. Iz pomenutih razloga Virginia d.o.o. danas je lider u oblasti biološke zaštite u Srbiji.</p>
               <p v-if="$route.params.podkategorije == 'Košnice bumbara' ">
                <strong>Virginia d.o.o.</strong>   ekskluzivni je uvoznik i distributer renomiranog belgijskog proizvođača bumbara i predatora – <strong>Biobest</strong> , za tržište Srbije.
               </p>

               <!-- <p v-if="$route.params.podkategorije == 'Osnovna đubriva' || $route.params.podkategorije == 'Vodotopiva đubriva' || $route.params.podkategorije == 'Folijarna đubriva' ">Naziv kompanije <strong> ICL SF / Everris </strong> (nekad Scotts) možda jeste nov, ali asortiman proizvoda, kojim se pozicionirao na svetskom tržištu, je odavno dobro poznat i renomiran. Everris je deo ICL grupe – globalnog lidera u proizvodnji najkvalitetnijih specijalnih đubriva i hemijskih komponenti za specifične namene. <br><br>
                 Agroleaf Power linija đubriva sadrži visok nivo makroelemenata, mikroelemenata i biostimulatora i prvenstveno je namenjena folijarnoj prihrani useva. Zbog svog sastava i čistoće, reakcija biljke na primenu ovih formulacija je neverovatno brza. Folijarna prihrana sastavni je deo ishrane useva i primenjuje se u svim oblastima poljoprivrede, od povrtartstva, voćarstva, do ratarstva i cvećarstva.
                </p> -->
            </div>
            <div class="opis" v-for="kat in kategorije" v-show="$route.params.kategorije == kat.kat_naziv " >
              <div class="" v-html="kat.kat_opis"></div>
            </div>

  <pojedinacna v-if="pojedinacna"></pojedinacna>
      </div>

      </div>
    </div>

    <slide  v-if="showterms"></slide>
    <manufactur v-if="" v-show="showmanufectur"></manufactur>
  </div>


</template>

<script>
import pojedinacna from '@/components/pojedinacna'
import slide from '@/components/slide'
import manufactur from '@/components/manufactur'
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  components: {
  pojedinacna,
  slide,
  manufactur
  },
  data () {
  return {
      list:"",
  }
},
computed:{
  ...mapGetters([
    'pro',
    'propics',
    'naziv',
    'showterms',
    'showmanufectur',
    'pak',
    'pojedinacna',
    'brandurl',
    'proprourl',
    'proname',
    'getopis',
    'kategorije',
    'kurs'


  ]),

},
watch:{
    $route:function(to, from){

    }

},

methods:{
  savet(){
    window.open("http://localhost:8080/saveti/"+ this.$route.params.podkategorije, "_blank");
    // this.$router.push("/saveti/" + this.$route.params.podkategorije)
  },
  async poruci(id){
    await this.getsinglpk(id).then(()=>{
      this.setpojedinacna(true)
    })

  },

  manu(e){
    this.setmanufectur(!this.showmanufectur);
      e.stopPropagation()
  },
  term(e,id,name){
    this.setproname(name)
    this.getpropics(id)

    this.setterms(!this.showterms);
      e.stopPropagation()
  },
      ...mapActions([
          'getsinglpk',
          'getpropics'
      ]),
      ...mapMutations([
        'setterms',
        'setmanufectur',
        'setpojedinacna',
        'setproname'

    ]),


},

mounted(){
  document.getElementById('ikona').scrollIntoView(true)
this.setpojedinacna(false)



}

}
</script>

<style >
details{
  border: none
}
summary::-webkit-details-marker {
    display: none;
}
summary:before {
    content: "\2714"; /* the new icon */
    color: #696f7c;
    margin-right: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/podkategorije.vue